import React, {Component, useEffect, useState, useRef} from 'react';
import { connect } from 'react-redux';

import axios from 'axios';
import Button from "../../ui/components/buttons/button";
import FormTextField from "../../ui/components/form-controls/form-text-field";

import {useHistory, withRouter} from "react-router-dom";
import TitleBox from "../title-box";
import FormDateField from "../../ui/components/form-controls/form-date-field";

import "./application.css";
import {_getPolicy, _storePolicy} from "../../store/policy/service";
import * as moment from "moment";
import {_getSite, _getStep} from "../../store/system/service";
import {_searchAddress} from "../../store/addresses/service";
import LabelledCheckbox from "../../ui/components/form-controls/labelled-checkbox";
import AddressDropdown from "../address-dropdowns";
import {useTranslation} from "react-i18next";
import Template from "../template";
import RadioBox from "../radio-box";
import {Formik, Form, Field} from "formik";
import * as yup from "yup";
import BalloonTip from "../balloon-tip/balloon-tip";
import {_scrollToComponent, _initYum, _gaPushEvent, _gaPushData} from "../../utils/utility";
import FormSelectField from "../../ui/components/form-controls/form-select-field";

const Application = (props) => {
    const options = [
        {
            label: 'Yes',
            value: 'true'
        },
        {
            label: 'No',
            value: 'false'
        }
    ];

    const { t, i18n } = useTranslation();

    useEffect(() => {
        window.scrollTo(0, 0);
        _gaPushData({
            'pageStep': 'Apply – Contact Info',
            'vPath': '/apply-contact-info',
            'event': 'vpageview'
        });
    }, [])

    const continueNextPage = (values, setSubmitting) => {
        // validate address
        /*
        if (!values.sameAsInsuredAddress && !validateAddress()) {
            return;
        } 
        */
        props.policy.policySME.applicant.mobileNo = values.mobileNo;
        props.policy.policySME.applicant.email = values.email;
        props.policy.policySME.applicant.forAttentionOf = values.companyName.toUpperCase();
        props.policy.policySME.applicant.hasInterestedParty = values.hasInterestedParty;
        props.policy.policySME.interestedParty.corporateName = values.corporateName.toUpperCase();
        props.policy.policySME.interestedParty.role = values.role;
        props.policy.policySME.applicant.mobileNoCountryCode = '65'; //default to SGP for now

        if(values.hasInterestedParty === 'false'){
            props.policy.policySME.interestedParty.corporateName = "";
            props.policy.policySME.interestedParty.role = "";
        } else {
            _gaPushEvent("saveparinterestedparty");
        }

        console.log(JSON.stringify(props.policy, null, 2));
        props.storePolicy(props.policy);
        setSubmitting(false);
        props.history.push((props.site ? '/' + props.site : '') + '/application/confirm');
    }

    const topCompRef = useRef(null);
    const middleCompRef = useRef(null);
    const bottomCompRef = useRef(null);

    _initYum(yup);
    const validationSchema = yup.object().shape({
        companyName: yup.string().
            required(() => {
                if(window.innerWidth>768) {
                    _scrollToComponent(topCompRef);
                }
                return t('contactPerson.validationMessage.required');
            }),
        mobileNo: yup.string()
            .matches(/^[0-9a-zA-Z\-,()]*$/g, t('mobileNumber.validationMessage.pattern'), () => {
                if(window.innerWidth>768) {
                    _scrollToComponent(topCompRef);
                }
            })
            .required(() => {
                if(window.innerWidth>768) {
                    _scrollToComponent(topCompRef)
                }
                return t('mobileNumber.validationMessage.required');
            })
            .min(8, t('mobileNumber.validationMessage.minLength')),
        email: yup.string()
            .required(() => {
                if(window.innerWidth>768) {
                    _scrollToComponent(topCompRef);
                }
                return t('email.validationMessage.required');
            }).matches(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/, t('email.validationMessage.pattern'), () => {
                if(window.innerWidth>768) {
                    _scrollToComponent(topCompRef);
                }
            }),
        hasInterestedParty: yup.string(),
        corporateName: yup.string()
            .when('hasInterestedParty', {
                is: "true",
                then: yup.string().required(() => {
                    if(window.innerWidth>768) {
                        _scrollToComponent(bottomCompRef);
                    }
                    return t('interestedParty.corporateName.validationMessage.required');
                })
            }),
        role: yup.string()
            .when('hasInterestedParty', {
                is: "true",
                then: yup.string().required(() => {
                    if(window.innerWidth>768) {
                        _scrollToComponent(bottomCompRef);
                    }
                    return t('interestedParty.role.validationMessage.required');
                })
            })
        
    });

    const initialValues = {
        companyName: props.policy.policySME.applicant.forAttentionOf || "",
        mobileNo: props.policy.policySME.applicant.mobileNo || "",
        email: props.policy.policySME.applicant.email || "",
        hasInterestedParty: props.policy.policySME.applicant.hasInterestedParty || "false",
        corporateName: props.policy.policySME.interestedParty.corporateName || "",
        role: props.policy.policySME.interestedParty.role || ""
    }

    const interestedPartyOptions = [
        {
            "text": "Landlord",
            "value": "Landlord"
        },
        {
            "text": "Bank",
            "value": "Bank"
        },
    ];

    return (
        <Template simple="Application" leftNav step={props.step} policy={props.policy} site={props.site} prevPage="/application/uen">
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values, {setSubmitting}) => {
                    setSubmitting(true);
                    continueNextPage(values, setSubmitting);
                }}>
                {({values, errors, touched, handleChange, setFieldValue}) => (
                    <Form>
                        <div className="ApplicationPaddingStyle">


                        <div className="ApplicationInputGroupsStyle"  ref={topCompRef}>
                            <TitleBox>
                                Contact Information
                                <BalloonTip>
                                    Collected information will be used for:
                                    <ul className="ApplicationBalloonTipUlStyle">
                                        <li>Policy Delivery</li>
                                        <li>Claims Contact</li>
                                        <li>Renew Contract</li>
                                    </ul>
                                </BalloonTip>
                            </TitleBox>
                            <div className="ApplicationBufferStyle"></div>
                            <div className="ApplicationInputGroupStyle">
                                <div className="ApplicationInputBoxStyle Caps">
                                    <Field
                                        label="Contact Person Name"
                                        name="companyName"
                                        as={FormTextField}
                                        errorMessage={(touched.companyName && errors.companyName) ? errors.companyName : ''}
                                    />
                                </div>
                            </div>
                            <div className="ApplicationInputGroupStyle">
                                <div className="ApplicationInputBoxStyle">
                                    <Field
                                        inputMode={'numeric'}
                                        label="Contact Person Mobile Number"
                                        name="mobileNo"
                                        errorMessage={touched.mobileNo && errors.mobileNo ? errors.mobileNo : ''}
                                        as={FormTextField}
                                        maxLength={12}
                                    />
                                </div>
                            </div>
                            <div className="ApplicationInputGroupStyle" ref={middleCompRef}>
                                <div className="ApplicationInputBoxStyle">
                                    <Field
                                        label="Contact Person Email"
                                        name="email"
                                        errorMessage={touched.email && errors.email ? errors.email : ''}
                                        as={FormTextField}
                                    />
                                </div>
                            </div>
                        </div>
                        <TitleBox>
                            Do you need to add your land lord or bank to the policy?
                            <BalloonTip>
                                An interest party in any other person or company other than the insured name
                                with an insurable interest in the risk covered by the policy. Example: Landlord or Bank
                            </BalloonTip>
                        </TitleBox>
                        <Field
                            name="hasInterestedParty"
                            options={options}
                            as={RadioBox}
                        />
                        { values.hasInterestedParty === 'true' &&
                            <React.Fragment>
                                <div className="ApplicationInputGroupStyle ApplicationCompanyNameStyle" ref={bottomCompRef}>
                                    <div className="ApplicationInputBoxStyle Caps">
                                        <Field
                                            label="Company Name/Full Name"
                                            name="corporateName"
                                            as={FormTextField}
                                            errorMessage={touched.corporateName && errors.corporateName ? errors.corporateName : ''}
                                        />
                                    </div>
                                </div>

                            <div className="ApplicationInputGroupStyle">
                                <div className="ApplicationInputBoxStyle">
                                    <Field
                                        label="Role"
                                        name="role"
                                        as={FormSelectField}
                                        options={interestedPartyOptions}
                                        onChange={(val) => setFieldValue("role", val)}
                                        errorMessage={touched.role && errors.role ? errors.role : ''}
                                    >
                                    </Field>
                                </div>
                            </div>
                        </React.Fragment>
                        }

                        <div className="ApplicationInputButtonsGroupStyle">
                            <div className="ApplicationInputButtonsStyle">
                                <Button color="primary" type="submit">Continue</Button>
                            </div>
                        </div>
                        </div>
                    </Form>
                )}
            </Formik>

        </Template>
    );
}

// get status from redux (subscription)
const mapStateToProps = (state) => {
    const currPolicy = _getPolicy(state);

    return {
        policy: currPolicy,
        step: _getStep(state),
        site: _getSite(state)
    }
}

// send service request to redux
const mapDispatchToProps = {
    searchAddress: _searchAddress,
    storePolicy: _storePolicy,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Application));
